import { useContext } from 'react'
import { CardContext, defaultValue } from './Card/CardProvider'

export function useCard() {
  const context = useContext(CardContext)

  if (context === defaultValue) {
    throw new Error('not used within a CardProvider.')
  }

  return context
}
